export default __webpack_public_path__ + "static/media/emoji_events.40f0cc38.svg";